import { SettingsLayout, type SettingsSection } from "@nymbl/nos2-rules";

const SECTIONS: SettingsSection[] = [
  { label: "Users", href: "/dashboard/settings/users" },
  { label: "Audit log", href: "/dashboard/settings/audit" },
  { label: "Email", href: "/dashboard/settings/email" },
  { label: "Jobs", href: "/dashboard/settings/jobs" },
  { label: "System", href: "/dashboard/settings/system" },
];

interface SettingsPageProps {
  /** The section's page actions, in the top bar. */
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/** One settings section: the shared layout, with this app's sections. */
export function SettingsPage({ actions, children }: SettingsPageProps) {
  return (
    <SettingsLayout sections={SECTIONS} actions={actions}>
      {children}
    </SettingsLayout>
  );
}
